import { NgModule } from '@angular/core';
import { BlockService, PageModule, UtilsModule } from '@gallaghercp/core-frontend';
import { BlockOnePageComponent } from '@core-app/one-page/block-one-page.component';
import { OnePageHeroComponent } from '@core-app/one-page/partials/one-page-hero/one-page-hero.component';
import { OnePageHeroWithBoxesComponent } from '@core-app/one-page/partials/one-page-hero-with-boxes/one-page-hero-with-boxes.component';
import { OnePageCtaComponent } from '@core-app/one-page/partials/one-page-cta/one-page-cta.component';
import { OnePageNewComponent } from '@core-app/one-page/partials/one-page-new/one-page-new.component';
import { OnePageActionsComponent } from '@core-app/one-page/partials/one-page-actions/one-page-actions.component';
import { OnePageContactsComponent } from '@core-app/one-page/partials/one-page-contacts/one-page-contacts.component';
import { OnePageCalloutComponent } from '@core-app/one-page/partials/one-page-callout/one-page-callout.component';
import { OnePageFooterComponent } from '@core-app/one-page/partials/one-page-footer/one-page-footer.component';
import { LayoutModule } from '@core-app/layout/layout.module';
import {
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { RouterLink } from '@angular/router';
import { OnePageInstallComponent } from '@core-app/one-page/partials/one-page-install/one-page-install.component';
import { BlockHomeHeroBannerComponent } from '@core-app/one-page/partials/block-home-hero-banner/block-home-hero-banner.component';
import { OneDownloadComponent } from '@core-app/one-page/partials/one-download/one-download.component';
import { WalletPassDownloadComponent } from '@core-app/one-page/partials/wallet-pass-download/wallet-pass-download.component';
import { WalletPassShareComponent } from '@core-app/one-page/partials/wallet-pass-share/wallet-pass-share.component';
import { WalletPassBannerComponent } from '@core-app/one-page/partials/wallet-pass-banner/wallet-pass-banner.component';

@NgModule({
    declarations: [
        BlockOnePageComponent,
        OnePageHeroComponent,
        OnePageHeroWithBoxesComponent,
        OnePageCtaComponent,
        OnePageNewComponent,
        OnePageActionsComponent,
        OnePageContactsComponent,
        OnePageCalloutComponent,
        OnePageFooterComponent,
        OnePageInstallComponent,
        OneDownloadComponent,
        BlockHomeHeroBannerComponent,
        WalletPassDownloadComponent,
        WalletPassShareComponent,
        WalletPassBannerComponent,
    ],
    imports: [
        PageModule,
        UtilsModule,
        LayoutModule,
        MatAccordion,
        MatExpansionPanelTitle,
        MatExpansionPanelHeader,
        MatExpansionPanel,
        RouterLink,
    ],
    exports: [],
})
export class OnePageModule {
    constructor(protected blocks: BlockService) {
        this.blocks
            .addBlock('ONE-PAGE', BlockOnePageComponent)
            .addBlock('ONE-PAGE-HERO', OnePageHeroComponent)
            .addBlock('ONE-PAGE-HERO-BOXES', OnePageHeroWithBoxesComponent)
            .addBlock('ONE-PAGE-CTA', OnePageCtaComponent)
            .addBlock('ONE-PAGE-NEW', OnePageNewComponent)
            .addBlock('ONE-PAGE-ACTIONS', OnePageActionsComponent)
            .addBlock('ONE-PAGE-CONTACTS', OnePageContactsComponent)
            .addBlock('ONE-PAGE-CALLOUT', OnePageCalloutComponent)
            .addBlock('ONE-PAGE-FOOTER', OnePageFooterComponent)
            .addBlock('DOWNLOAD', OneDownloadComponent)
            .addBlock('HOME-BANNER', BlockHomeHeroBannerComponent)
            .addBlock('WALLET-PASS-DOWNLOAD', WalletPassDownloadComponent)
            .addBlock('WALLET-PASS-SHARE', WalletPassShareComponent)
            .addBlock('WALLET-PASS-BANNER', WalletPassBannerComponent);
    }
}
